module.exports = __webpack_public_path__ + "FSAlbert-Regular.0cf60237129faee54b6c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert-Regular.ttf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert-Regular.ttf
// module chunks = main